<div
  style="width: 100%; height: 100%;position: relative;display: flex;flex-direction: column;align-items: center;justify-content: center;height: 100%;">
  <h2>{{data.header}}</h2>
  <p>{{data.message}}</p>
  <button *ngIf="data.showReload" mat-raised-button color="primary" (click)="onReload();">
    App neu laden
  </button>
</div>
